
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { BlogEntry } from '@shared/models';

	@Component({})
	export default class ContactWidget extends BaseView {

		public list: BlogEntry[] = [];

		/** Fires when this component is laoded */
		public async mounted() {
			this.loading = true;
			try {
				const result = await this.$api.blogService.listEntries(0, 5);
				this.list = result.results;
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading blod entries');
			} finally {
				this.loading = false;
			}

		}

	}

